import { TreeNode } from '@b2b/common/utils/tree-node';
import { input, TODO } from '@b2b/types/core';
import angular from 'angular';

let id = 0;

class TreeNodeController<TModel = unknown> {
  static $inject = ['$element'];

  model = input<TModel>();

  nodeId = `acme-tree-node-${++id}`;
  node: TreeNode;

  treeCtrl: TODO;
  parentTreeNodeCtrl?: TreeNodeController;

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-tree-node');

    this.node = new TreeNode({
      id: this.nodeId,
      parent: this.parentTreeNodeCtrl || this.treeCtrl,
      children: [],
      value: this,
    });

    if (this.node.parent) {
      this.node.parent.add(this.node);
    }
  }

  add(node: TreeNode) {
    this.node.add(node);
  }
}

TreeNodeDirective.$inject = [];

function TreeNodeDirective() {
  return {
    restrict: 'A',
    require: {
      treeCtrl: '^acmeTree',
      parentTreeNodeCtrl: '?^^acmeTreeNode',
    },
    bindToController: {
      model: '<',
    },
    controllerAs: '$ctrl',
    controller: TreeNodeController,
    link: function ($scope, $element, $attrs) {},
  };
}

export const TreeNodeDirectiveModule = angular
  .module('acme.common.directive.tree.treeNode', [])
  .directive('acmeTreeNode', TreeNodeDirective).name;
